export default {

    // CATEGORIES
    TOOLBOX_ITEMS: 'Toolbox items',
    TOOLBOX_ITEMS_BREADCRUMBS: 'Toolbox items Breadcrumbs',
    BREADCRUMBS_HOME: 'Breadcrumbs - Home',
    TOP_BAR:'top bar',
    REDIRECT:'Redirect',
    SCOREBOARD:'scoreboard',
    SR_VIEW:'SR view',
    PAGE_VIEW:'Page View',

    // ACTIONS
    CLICK: 'Click',


    // LABELS
    SYSTEM_ITEM: 'System item',
    CUSTOM_ITEM: 'Custom item'

}



// WEBPACK FOOTER //
// ./constants/analytics.js